import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class AskConfirmationModal extends Component {
    render() {
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.closeModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {this.props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.question}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { this.props.onAskConfirmationResponse(false); }} color="primary">
                        {this.props.negativeOption}
                    </Button>
                    <Button onClick={() => { this.props.onAskConfirmationResponse(true); }} color="primary" autoFocus>
                        {this.props.positiveOption}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
AskConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    positiveOption: PropTypes.string.isRequired,
    negativeOption: PropTypes.string.isRequired,
    onAskConfirmationResponse: PropTypes.func.isRequired
};

export default AskConfirmationModal;